import { OdinController } from '@myosh/odin-components';
import type { MultiselectCheckboxProps } from './multiselect-checkbox.component';
import MultiselectCheckbox from './multiselect-checkbox.component';

interface HfMultiselectCheckboxProps extends MultiselectCheckboxProps {
  name: string;
}

export default function HfMultiselectCheckbox({
  control,
  name,
  value,
  onChange,
  textField,
  valueField,
  fieldValueConverter,
  ...rest
}: HfMultiselectCheckboxProps) {
  return (
    <OdinController
      name={name}
      control={control}
      onChange={onChange}
      defaultValue={value}
      fieldValueConverter={fieldValueConverter}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <MultiselectCheckbox
          {...rest}
          name={name}
          control={control}
          value={value}
          onChange={onChange}
          error={error?.message}
          textField={textField}
          valueField={valueField}
        />
      )}
    />
  );
}
